import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import {
    Row, Col, Button,
} from 'antd';
import { Link } from 'react-router-dom';
import MachineStatusBoxView from './MachineStatusBoxView';
import MachineAddContainer from '../containers/MachineAddContainer';
import constants from '../../constants';

class DashboardView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openForm: false,
        };
        this.onCancel = this.onCancel.bind(this);
        this.closeForm = this.closeForm.bind(this);
    }

    onCancel() {
        this.closeForm();
    }

    closeForm() {
        this.setState({
            openForm: false,
        });
    }

    render() {
        const addMachineBtn = (
            <Col md={24} lg={6}>
                <Button type="primary" style={{ margin: '10px 0' }} size="large" onClick={() => { this.setState({ openForm: true }); }}>
                    Agregar Maquina
                </Button>
            </Col>
        );
        const printQRBtn = (
            <Col md={24} lg={6}>
                <Button type="primary" size="large" style={{ margin: '10px 0' }} onClick={() => { this.setState({ openForm: true }); }}>
                    <Link to={`/printqr/${this.props.companyid}`}>
                        <span>
                            Print QRs
                        </span>
                    </Link>
                </Button>
            </Col>
        );
        return (
            <div>
                <Row gutter={8}>
                    <Col md={24} lg={12}>
                        <h1 style={{ margin: '10px 0' }}>
                            <FormattedMessage id="home.machine_list" />
                        </h1>
                    </Col>
                    { this.props.extraUser.type === constants.ADMIN_ROLE && addMachineBtn }
                    { this.props.extraUser.type === constants.SADMIN_ROLE && addMachineBtn }
                    { this.props.extraUser.type === constants.SUPV_ROLE && addMachineBtn }

                    { this.props.extraUser.type === constants.ADMIN_ROLE && printQRBtn }
                    { this.props.extraUser.type === constants.SADMIN_ROLE && printQRBtn }
                    { this.props.extraUser.type === constants.SUPV_ROLE && printQRBtn }
                </Row>
                <MachineAddContainer
                    openForm={this.state.openForm}
                    onCancel={this.onCancel}
                    closeForm={this.closeForm}
                    user={this.props.currentUser}
                    companyid={this.props.companyid}
                    extraUser={this.props.extraUser}
                />
                <Row gutter={8}>
                    {this.props.machines
                        .map(machine => (
                            <MachineStatusBoxView
                                key={machine.key}
                                id={machine.key}
                                name={machine.name}
                                status={machine.status}
                                user={this.props.currentUser}
                                extraUser={this.props.extraUser}
                            />
                        ))
                    }
                </Row>
            </div>
        );
    }
}
export default DashboardView;



// WEBPACK FOOTER //
// ./src/components/views/DashboardView.js